<script >
import { computed, defineAsyncComponent } from 'vue-demi';
import '@futuweb/quote-charts/lib/SparkChart/style/index.css';
const SparkChart = defineAsyncComponent(() => import('@futuweb/quote-charts/lib/SparkChart'));
const __sfc_main = {};
__sfc_main.props = {
  theme: Number,
  // 白肤-1/黑肤-3
  dataSource: Array,
  chartDataMap: Object,
  selfSelectedMap: Object,
  upDownColor: Number,
  // 红涨绿跌-0/绿涨红跌-1
  header: Object,
  // { show: true, column: [],}
  columnConfig: {
    type: Object,
    default: () => ({})
  },
  // { showRankTag: true, showTrend, showIncrease, showAddWch, showAddWchCount }
  wchNumMap: {
    type: Object,
    default: () => ({})
  },
  addAllConfig: {
    type: Object,
    default: () => ({})
  },
  tagMap: {
    type: Object,
    default: () => ({})
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    usePageType
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const props = __props;
  const column = computed(() => {
    return props.header.column || {};
  });

  // 计算 走势、涨幅、自选 列是否非全部展示，适当扩大 col-name 的宽度
  const calcWiderColName = computed(() => {
    const {
      showTrend,
      showIncrease,
      showAddWch
    } = props.columnConfig;
    return Number(showTrend) + Number(showIncrease) + Number(showAddWch) < 3;
  });
  const emits = __ctx.emit;
  return {
    isPC,
    column,
    calcWiderColName,
    emits
  };
};
__sfc_main.components = Object.assign({
  SparkChart
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div :class="['rank-list', { PC: isPC, dark: theme === 3, 'wider-col-name': calcWiderColName }]">
        <div class="add-all-container" v-if="addAllConfig.show">
            <div class="add-all" @click="emits('addAllClick')">{{ addAllConfig.text }}</div>
        </div>
        <ul>
            <li class="rank-header" v-if="header.show">
                <div class="col-name">{{ column.name }}</div>
                <div class="col-right-wrap">
                    <div class="col-trend" v-if="columnConfig.showTrend">{{ column.trend }}</div>
                    <div class="col-increase" v-if="columnConfig.showIncrease">{{ column.increase }}</div>
                    <div class="col-icon" v-if="columnConfig.showAddWch">{{ column.wch }}</div>
                </div>
            </li>
            <li
                class="rank-item"
                v-for="(item, i) in dataSource"
                :key="item.stockId"
                @click="emits('itemClick', $event, item)"
                :class="{ 'rank-item-with-stock-tag': !!tagMap[item.symbol] }"
            >
                <div class="col-name align-left">
                    <div class="rank-item__num" v-if="columnConfig.showRankTag">
                        <div v-if="i < 3" :class="`top-3 no__${i + 1}`"></div>
                        <span v-else class="num-text">{{ i + 1 }}</span>
                    </div>
                    <div class="rank-item__text">
                        <p class="rank-item__stock-name text-over">{{ item.name }}</p>
                        <p class="rank-item__stock-symbol text-over">{{ item.symbol }}</p>
                        <p v-if="tagMap[item.symbol]" class="rank-item__stock-tag text-over">
                            {{ tagMap[item.symbol] }}
                        </p>
                    </div>
                </div>
                <div class="col-right-wrap">
                    <div class="col-trend align-right" v-if="columnConfig.showTrend">
                        <SparkChart
                            v-if="chartDataMap && chartDataMap[item.stockId]"
                            class="spark-chart"
                            :dataSource="chartDataMap && chartDataMap[item.stockId]"
                            :upDownColor="upDownColor"
                        />
                    </div>
                    <div
                        v-if="columnConfig.showIncrease"
                        :class="[
                            'col-increase',
                            'align-right',
                            upDownColor == 0 ? 'red-up' : 'green-up',
                            { up: item.priceChange > 0, down: item.priceChange < 0 }
                        ]"
                    >
                        {{ item.priceChange > 0 ? `+${item.ratioPriceChange}` : item.ratioPriceChange }}
                    </div>
                    <div class="col-icon align-center" v-if="columnConfig.showAddWch">
                        <img
                            v-if="selfSelectedMap && selfSelectedMap[item.stockId]"
                            src="./images/selected.png"
                            @click.stop="emits('iconClick', $event, item, true)"
                            alt="selected"
                        />
                        <img
                            v-else
                            src="./images/not-select.png"
                            @click.stop="emits('iconClick', $event, item, false)"
                            alt="not-select"
                        />
                        <div v-if="columnConfig.showAddWchCount" class="number">
                            {{ wchNumMap && wchNumMap[item.stockId] }}
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<style lang="less" scoped>
@import './index.less';
</style>
